export interface InrixVolumeFeature {
  id: string;
  orderItemId: string;
  osmSegmentId: string;
  sourceSegmentId: string;
  adt: number;
  volumes: number[];
  adtMin: number;
  adtMax: number;
  volMin: number;
  volMax: number;
}

const parseSerializedIntArray = (value: unknown): number[] | null => {
  if (Array.isArray(value)) {
    const parsed = value
      .map((entry) => Number(entry))
      .filter((entry) => !Number.isNaN(entry));
    return parsed.length === value.length ? parsed : null;
  }

  if (typeof value !== "string") {
    return null;
  }

  const trimmed = value.trim();
  if (!trimmed) {
    return null;
  }

  try {
    const parsed = JSON.parse(trimmed);
    if (Array.isArray(parsed)) {
      const result = parsed
        .map((entry) => Number(entry))
        .filter((entry) => !Number.isNaN(entry));
      return result.length === parsed.length ? result : null;
    }
  } catch {
    // Fall through to comma-separated parsing.
  }

  const split = trimmed
    .replace(/^\[|\]$/g, "")
    .split(",")
    .map((entry) => Number(entry.trim()))
    .filter((entry) => !Number.isNaN(entry));

  return split.length > 0 ? split : null;
};

export const parseInrixVolumeFeature = (feature: {
  get: (key: string) => unknown;
}): InrixVolumeFeature | null => {
  const id = String(feature.get("id") ?? "");
  const orderItemId = String(feature.get("orderItemId") ?? "");
  const osmSegmentId = String(feature.get("osmSegmentId") ?? "");
  const sourceSegmentId = String(feature.get("sourceSegmentId") ?? "");

  const adt = Number(feature.get("adt"));
  if (Number.isNaN(adt)) {
    return null;
  }

  const volumes = parseSerializedIntArray(feature.get("volumes")) ?? [];

  const adtMin = Number(feature.get("adtMin") ?? NaN);
  const adtMax = Number(feature.get("adtMax") ?? NaN);
  const volMin = Number(feature.get("volMin") ?? NaN);
  const volMax = Number(feature.get("volMax") ?? NaN);

  return {
    id,
    orderItemId,
    osmSegmentId,
    sourceSegmentId,
    adt,
    volumes,
    adtMin: Number.isNaN(adtMin) ? 0 : adtMin,
    adtMax: Number.isNaN(adtMax) ? 0 : adtMax,
    volMin: Number.isNaN(volMin) ? 0 : volMin,
    volMax: Number.isNaN(volMax) ? 0 : volMax,
  } as InrixVolumeFeature;
};
